<template>
  <span class="mb-0" style="flex: 0 0 auto">
    <v-btn
      v-if="profile && profile.contacts.length > 1 && isTrysilhus === false"
      :class="{ 'my-2': block, 'mr-2': !block }"
      color="primary"
      :block="block"
      @click="changeContact = true"
    >
      <v-icon left>mdi-autorenew</v-icon>
      Bytt aktivt firma
    </v-btn>

    <v-divider
      v-if="profile && profile.contacts.length > 1 && isTrysilhus === false"
    ></v-divider>

    <BaseDialog
      v-if="contacts"
      v-model="changeContact"
      dialogIcon="mdi-account-edit"
      title="Bytt firma"
    >
      <template v-slot>
        <v-subheader>Aktivt firma</v-subheader>
        <v-list class="py-0" color="cardSurface">
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="yellow"> mdi-office-building-outline </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ activeContact.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <v-subheader>Bytt til</v-subheader>
        <v-list
          class="py-0"
          v-for="(contact, index) in contacts"
          :key="index"
          color="cardSurface"
        >
          <v-divider v-if="index !== 0"></v-divider>
          <v-list-item @click="setActiveContact(contact)">
            <v-list-item-icon>
              <v-icon> mdi-office-building-outline </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ contact.contactName }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </template>
    </BaseDialog>
  </span>
</template>

<script lang="ts">
import Vue from "vue";
import api from "@/api/api";
import { mapGetters } from "vuex";

import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  name: "AddContactDialog",
  props: {
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      changeContact: false,
    };
  },
  methods: {
    async setActiveContact(contact) {
      //Change active contact/company
      await api.setActive(contact).then(() => {
        //Refresh and go to home page
        window.location.href = process.env.VUE_APP_REDIRECTURI || "";
      });
    },
  },

  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isTrysilhus: "shared/isTrysilhus",
    }),
    activeContact() {
      return this.profile?.contact;
    },
    contacts() {
      return this.profile?.contactPersonRelations.filter(
        (x) => x.contactId !== this.profile.contact.id && x.inActive != true
      );
    },
  },

  components: {
    BaseDialog,
  },
});
</script>
